import { createFileRoute } from "@tanstack/react-router";
import { ProductPage, buildProductHead } from "@/components/shop/ProductPage";
import { metalDict } from "@/lib/shop/products/metal";
import { alternateLinkList } from "@/lib/i18n/locale";

export const Route = createFileRoute("/shop_/metal")({
  head: () => ({
    ...buildProductHead(metalDict),
    links: alternateLinkList("/shop/metal", "en"),
  }),
  component: () => <ProductPage dict={metalDict} />,
});
